import IndexTableFiltersPanel from '../index-table/filterComponents/IndexTableFiltersPanel';
import MessageIndexTableFiltersPanelMultiSelect from './MessageIndexTableFiltersPanelMultiSelect';

export default class MessagesIndexTableFiltersPanel extends IndexTableFiltersPanel {
    IndexTableFiltersPanelMultiSelectClass = MessageIndexTableFiltersPanelMultiSelect;

    /* 
        remove selected options if new option is none
        remove none option in new option !== none
    */

    addOrReplaceQuery(query) {
        if (query.slug !== 'Project') {
            super.addOrReplaceQuery(query);
            return;
        }

        let currentQueries = this.state.queries
        let sameQueryIndex = currentQueries.findIndex(x => x.slug === query.slug && x.index === query.index)
        if (sameQueryIndex > -1) {
            query.color = currentQueries[sameQueryIndex].color
            currentQueries.splice(sameQueryIndex, 1)
        }

        let hasNoneOption = currentQueries.findIndex(x => x.value === 0) > -1;

        let nextQueries = [];
        if (query.value === 0) {
            nextQueries = [query]
        } else if (hasNoneOption && query.value !== 0) {
            var noneOptionIndex = currentQueries.findIndex(x => x.value === 0)
            currentQueries.splice(noneOptionIndex, 1);
            nextQueries = [
                ...currentQueries,
                query
            ]
        } else {
            nextQueries = [
                ...currentQueries,
                query
            ]
        }

        this.setState({queries: nextQueries})
        this.addCollectionStateValue(query.slug);
        this.props.onFiltersChange(nextQueries)
    }
} 